import DashboardCard from "./DashboardCard";
import { BsPeople } from "react-icons/bs";
import { useSelector } from "react-redux";
import TopCommunityBotsLoader from "./top-community-bot/TopCommunityBotsLoader";
import styles from "../../styles/Components/new-dashboard/TopCommunityBots.module.css";
import CommunityPreview from "./top-community-bot/CommunityPreview";
import CommunityBotsContent from "../../shared/CommunityBotsContent";

function TopCommunityBots() {
  const {
    dashboard: { botInfoStatus, communityBots },
  } = useSelector((state) => state);

  const showLoading =
    botInfoStatus === "loading" && Object.keys(communityBots).length === 0;

  return (
    <DashboardCard
      title="Top Community Bots"
      titleIcon={<BsPeople />}
      type="topCommunity"
      bodyClassName={styles.cardBody}
      preview={<CommunityPreview />}
      id="community-bots"
    >
      {showLoading && <TopCommunityBotsLoader />}

      <CommunityBotsContent />
    </DashboardCard>
  );
}

export default TopCommunityBots;
